import type { SpecConstraintViewModel } from 'api/types/product-type/SpecConstraintViewModel';
import { SpecSelectionMode, SpecValueType } from 'api/types/product-type/SpecConstraintViewModel';

/**
 * API returns SpecValueType as string enum names (JsonStringEnumConverter).
 * Normalize wire values to numeric SpecValueType for UI and query building.
 */
export function normalizeSpecValueType(valueType: unknown): SpecValueType {
  if (valueType === SpecValueType.Number || valueType === 0 || valueType === '0' || valueType === 'Number') {
    return SpecValueType.Number;
  }
  if (valueType === SpecValueType.String || valueType === 1 || valueType === '1' || valueType === 'String') {
    return SpecValueType.String;
  }
  if (valueType === SpecValueType.Enum || valueType === 2 || valueType === '2' || valueType === 'Enum') {
    return SpecValueType.Enum;
  }
  return SpecValueType.String;
}

/** Unwrap ServiceResult data: plain array or legacy paginated envelope. */
export function normalizeSpecConstraintList(data: unknown): SpecConstraintViewModel[] {
  if (data == null) return [];
  if (Array.isArray(data)) {
    return data.map(normalizeSpecConstraint);
  }
  if (typeof data === 'object' && 'items' in data) {
    const items = (data as { items?: unknown }).items;
    if (Array.isArray(items)) {
      return items.map(normalizeSpecConstraint);
    }
  }
  return [];
}

export function normalizeSpecConstraint(raw: SpecConstraintViewModel): SpecConstraintViewModel {
  return {
    ...raw,
    valueType: normalizeSpecValueType(raw.valueType),
    selectionMode: normalizeSpecSelectionMode(raw.selectionMode),
  };
}

export function normalizeSpecSelectionMode(mode: unknown): SpecSelectionMode {
  if (mode === SpecSelectionMode.Multi || mode === 1 || mode === '1' || mode === 'Multi') {
    return SpecSelectionMode.Multi;
  }
  return SpecSelectionMode.Single;
}
